<template>
  <el-form label-width="100px" :model="workOrder">
    <el-form-item label="状态：">
      {{ statusEnum[workOrder.status] }}
    </el-form-item>
    <el-form-item label="当前承接人：">
      {{
        workOrder.acceptUsers &&
        workOrder.acceptUsers.map((item) => item.userName).join(",")
      }}
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "workOrderStepInfo",
  props: {
    workOrder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      statusEnum: {
        0: "待处理",
        1: "已处理",
        2: "已关闭",
        3: "已驳回",
        4: "处理中",
      },
    };
  },
  methods: {
    remind() {
      this.$emit("remind");
    },
  },
  computed: {
    showRemind() {
      return (
        this.workOrder.status === 0 &&
        ["work.mySubmit.detail", "workmange.workQuality.detail"].includes(
          this.$route.name,
        )
      );
    },
  },
};
</script>

<style lang="less" scoped></style>
